/**
 * @fileoverview > handler for the "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdCacheKeys } from "./constants";
import type {
  DeleteEngagementAppGroupIdCanvasWorkflowIdVersionsVersionIdProps,
  DiscardCanvasVersionResult,
} from "./types";

export const discardCanvasVersion = reactQueryMutationAdapter(
  engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdCacheKeys,
  (
    props: DeleteEngagementAppGroupIdCanvasWorkflowIdVersionsVersionIdProps
  ): Promise<DiscardCanvasVersionResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/canvas/${props.canvasId}/versions/${props.versionId}`,
      "DELETE",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
